// /assets/sticky-add-to-cart.js - ENHANCED VERSION

document.addEventListener('DOMContentLoaded', () => {
  const productForm = document.querySelector('product-form');
  if (!productForm) return;

  const originalButtonContainer = productForm.querySelector('.product-form__buttons');
  const stickyBar = document.getElementById('sticky-add-to-cart-bar');
  
  if (!originalButtonContainer || !stickyBar) return;

  // --- Visibility Logic (Unchanged) ---
  const observer = new IntersectionObserver(
    (entries) => {
      const [entry] = entries;
      stickyBar.classList.toggle('sticky-atc-bar--visible', !entry.isIntersecting);
    },
    { rootMargin: '0px', threshold: 0 }
  );
  // Don't start observing immediately. Wait for the first scroll event to begin.
  window.addEventListener('scroll', () => {
    observer.observe(originalButtonContainer);
  }, { once: true });
  // --- Button Click Logic (Unchanged) ---
  const stickyButton = stickyBar.querySelector('.product-form__submit');
  const realButton = productForm.querySelector('.product-form__submit');

  if (stickyButton && realButton) {
    stickyButton.addEventListener('click', (event) => {
      event.preventDefault();
      realButton.click();
    });
  }

  // --- START: ENHANCED LOGIC to sync variant changes ---
  const mutationObserver = new MutationObserver((mutations) => {
    // 1. Get all the information we need from the page first.
    const originalPriceElement = document.querySelector('.price__container .price-item--regular, .price__container .price-item--sale');
    const priceHTML = originalPriceElement ? originalPriceElement.innerHTML : ''; // Get price HTML, or an empty string if not found.
    const realButtonText = realButton.querySelector('span').textContent.trim();
    const isSoldOut = realButton.hasAttribute('disabled');
    
    // 2. Find our single target element inside the sticky button.
    const stickyButtonContentWrapper = document.getElementById('sticky-button-content-wrapper');
    if (!stickyButtonContentWrapper) return;
    
    // 3. Set the disabled state of the entire sticky button.
    stickyButton.toggleAttribute('disabled', isSoldOut);
    
    // 4. Now, build the final content in one step.
    if (isSoldOut) {
        // If the product is sold out, just show the "Sold Out" text.
        stickyButtonContentWrapper.innerHTML = realButtonText;
    } else {
        // Otherwise, combine the button text and the price.
        stickyButtonContentWrapper.innerHTML = `${realButtonText} - ${priceHTML}`;
    }
  });
  // --- END: ENHANCED LOGIC ---

  mutationObserver.observe(realButton, { attributes: true, childList: true, subtree: true });

  // Trigger the observer once on page load to set the initial state.
  setTimeout(() => realButton.dispatchEvent(new Event('change')), 100);
});